import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNeovimComponent } from './simple-icons-neovim.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNeovimComponent ],
    exports:      [ SimpleIconsNeovimComponent ],
    bootstrap:    []
})
export class SimpleIconsNeovimModule {}
